import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../i18n/i18n';
import { FaPlus, FaSearch, FaEye, FaEdit, FaTrash, FaToggleOn, FaToggleOff, FaDollarSign, FaPrint, FaFileExcel } from 'react-icons/fa';
import {
  getEquipments,
  deleteEquipments,
  toggleEquipmentStatus,
} from '../../../../redux/Slices/EquipmentSlice';
import { useTitle } from '../../../../shared/hooks/TitleContext';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import PdfPreviewModal from '../../Accounting/Reports/components/PdfPreviewModal';

const normalizeListResponse = (payload) => {
  if (!payload) return { items: [], pagination: null };
  if (Array.isArray(payload?.data?.data)) return { items: payload.data.data, pagination: payload.data };
  if (Array.isArray(payload?.data)) return { items: payload.data, pagination: payload.pagination || payload.meta || null };
  if (Array.isArray(payload?.items)) return { items: payload.items, pagination: payload.pagination || payload.meta || null };
  if (Array.isArray(payload)) return { items: payload, pagination: null };
  return { items: [], pagination: payload.pagination || payload.meta || null };
};

const EquipmentsPdfPage = ({ id, chunk, chunkIndex, totalChunks, isPreview, isRTL, t, publicUrl, headerLogo, activeFilters }) => {
  const reportDate = new Date().toLocaleDateString(isRTL ? 'ar-SA' : 'en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  const reportTitle = isRTL ? 'تقرير المعدات' : 'Equipments Report';

  return (
    <div
      id={id}
      style={{
        width: '794px',
        height: '1123px',
        backgroundColor: '#ffffff',
        color: '#000000',
        padding: '40px',
        boxSizing: 'border-box',
        fontFamily: '"Times New Roman Bold", "Times New Roman", "Times", serif',
        fontWeight: 'bold',
        ...(isPreview ? { marginBottom: '20px', boxShadow: '0 2px 14px rgba(0,0,0,0.18)' } : {}),
      }}
    >
      <div style={{ border: '5px solid #000', padding: '3px', backgroundColor: '#ffffff', boxSizing: 'border-box', width: '100%', height: '1043px' }}>
        <div style={{
          border: '2px solid #000',
          height: '1033px',
          padding: '18px 18px 10px',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          fontFamily: '"Times New Roman Bold", "Times New Roman", "Times", serif',
          fontWeight: 'bold',
          direction: isRTL ? 'rtl' : 'ltr',
          backgroundColor: '#ffffff',
          boxSizing: 'border-box',
          width: '100%',
        }}>
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundImage: `url(${headerLogo})`, backgroundSize: '95%', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', opacity: 0.08, zIndex: 0, pointerEvents: 'none' }} />
          <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
            <img src={`${publicUrl}/HeaderAce.png`} alt="Header" style={{ width: '100%', height: 'auto', objectFit: 'contain', marginBottom: '8px', borderBottom: '4px double #000', paddingBottom: '8px', flexShrink: 0 }} crossOrigin="anonymous" />
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'visible', minHeight: 0, paddingBottom: '120px' }}>
              <h2 style={{ textAlign: 'center', fontSize: '16px', fontWeight: '700', color: '#000080', margin: '6px 0 4px', fontFamily: '"Times New Roman", serif' }}>
                {reportTitle}
              </h2>
              <p style={{ textAlign: 'center', fontSize: '11px', margin: '0 0 4px', fontFamily: '"Times New Roman", serif', color: '#333' }}>
                {reportDate}
              </p>
              {activeFilters ? (
                <div style={{ textAlign: 'center', fontSize: '10px', margin: '0 0 4px', color: '#555', fontFamily: '"Times New Roman", serif' }}>
                  {activeFilters}
                </div>
              ) : null}
              <div style={{ textAlign: isRTL ? 'left' : 'right', fontSize: '10px', margin: '0 0 4px', color: '#555', fontFamily: '"Times New Roman", serif' }}>
                {isRTL ? `صفحة ${chunkIndex + 1} / ${totalChunks}` : `Page ${chunkIndex + 1} / ${totalChunks}`}
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px', border: '1px solid #000', fontFamily: '"Times New Roman", serif', backgroundColor: 'rgba(255,255,255,0.7)' }}>
                <thead>
                  <tr style={{ backgroundColor: 'rgba(238, 242, 247, 0.7)' }}>
                    <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', fontWeight: '700', width: '36px', backgroundColor: 'rgba(238, 242, 247, 0.7)' }}>{t('equipments.printTemplate.number', { defaultValue: '#' })}</th>
                    <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', fontWeight: '700', backgroundColor: 'rgba(238, 242, 247, 0.7)' }}>{t('equipments.printTemplate.nameAr')}</th>
                    <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', fontWeight: '700', backgroundColor: 'rgba(238, 242, 247, 0.7)' }}>{t('equipments.printTemplate.nameEn')}</th>
                    <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', fontWeight: '700', backgroundColor: 'rgba(238, 242, 247, 0.7)' }}>{t('equipments.printTemplate.code')}</th>
                    <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', fontWeight: '700', backgroundColor: 'rgba(238, 242, 247, 0.7)' }}>{t('equipments.printTemplate.quantity', { defaultValue: 'الكمية' })}</th>
                    <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', fontWeight: '700', backgroundColor: 'rgba(238, 242, 247, 0.7)' }}>{t('equipments.printTemplate.status')}</th>
                  </tr>
                </thead>
                <tbody>
                  {chunk.items.map((equipment, idx) => {
                    const globalIdx = chunk.startIndex + idx;
                    const bg = globalIdx % 2 === 0 ? 'rgba(255,255,255,0.7)' : 'rgba(248,248,248,0.7)';
                    return (
                      <tr key={equipment.id || idx} style={{ backgroundColor: bg }}>
                        <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', verticalAlign: 'middle', width: '36px', backgroundColor: bg }}>{globalIdx + 1}</td>
                        <td style={{ border: '1px solid #000', padding: '6px', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left', verticalAlign: 'middle', backgroundColor: bg }}>{equipment.name_ar || '—'}</td>
                        <td style={{ border: '1px solid #000', padding: '6px', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left', verticalAlign: 'middle', backgroundColor: bg }}>{equipment.name_en || '—'}</td>
                        <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', verticalAlign: 'middle', backgroundColor: bg }}>{equipment.code || '—'}</td>
                        <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', verticalAlign: 'middle', backgroundColor: bg }}>{equipment.quantity ?? '—'}</td>
                        <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', verticalAlign: 'middle', backgroundColor: bg }}>{equipment.is_active ? t('equipments.active') : t('equipments.inactive')}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div style={{ position: 'absolute', bottom: '10px', left: '18px', right: '18px', flexShrink: 0 }}>
              <img src={`${publicUrl}/FooterAce.png`} alt="Footer" style={{ width: '100%', height: 'auto', objectFit: 'contain', borderTop: '4px double #000' }} crossOrigin="anonymous" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Equipments = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setTitle } = useTitle();
  const [equipments, setEquipments] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [perPage, setPerPage] = useState(10);
  const [perPageInput, setPerPageInput] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [equipmentToDelete, setEquipmentToDelete] = useState(null);
  const [equipmentForPrint, setEquipmentForPrint] = useState(null);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  const [pdfType, setPdfType] = useState(null); // 'single' or 'all'
  const [previewEquipment, setPreviewEquipment] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewType, setPreviewType] = useState(null); // 'single' or 'all'
  const [pdfRowsPerPage, setPdfRowsPerPage] = useState(0);
  const isRTL = i18n.language === 'ar';
  const publicUrl = process.env.PUBLIC_URL || '';
  const headerLogo = `${publicUrl}/ACE.png`;

  const paginationInfo = useMemo(() => {
    if (!pagination) return { current_page: currentPage, last_page: 1 };
    return {
      current_page: pagination.current_page || pagination.page || currentPage,
      last_page: pagination.last_page || pagination.total_pages || 1,
    };
  }, [pagination, currentPage]);

  const pdfChunks = useMemo(() => {
    const rpp = pdfRowsPerPage || 20;
    if (!equipments.length) return [];
    const chunks = [];
    for (let i = 0; i < equipments.length; i += rpp) {
      chunks.push({ items: equipments.slice(i, i + rpp), startIndex: i });
    }
    return chunks;
  }, [equipments, pdfRowsPerPage]);

  const activeFiltersForPdf = useMemo(() => {
    const parts = [];
    if (searchTerm) parts.push(`${isRTL ? 'بحث' : 'Search'}: ${searchTerm}`);
    if (statusFilter === '1') parts.push(`${isRTL ? 'الحالة' : 'Status'}: ${t('equipments.active')}`);
    else if (statusFilter === '0') parts.push(`${isRTL ? 'الحالة' : 'Status'}: ${t('equipments.inactive')}`);
    return parts.join(' | ');
  }, [searchTerm, statusFilter, t, isRTL]);

  const fetchEquipments = useCallback(
    async (page = currentPage, search = searchTerm, status = statusFilter, perPageValue = perPage) => {
      try {
        setIsLoading(true);                             
        const payload = await dispatch(
          getEquipments({
            page,
            per_page: perPageValue,
            search: search || undefined,
            is_active: status !== '' ? status : undefined,
          })
        ).unwrap();
        const { items, pagination: paginationMeta } = normalizeListResponse(payload);
        setEquipments(items);
        setPagination(paginationMeta);
      } catch (error) {
        toast.error(error || t('equipments.messages.fetchError'), { rtl: isRTL });
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch, currentPage, searchTerm, statusFilter, perPage]
  );


  // Sync on mount and when back online
  useEffect(() => {
    fetchEquipments(1);
    const handleReconnect = () => {
      fetchEquipments(currentPage, searchTerm, statusFilter, perPage);
    };
    window.addEventListener('online', handleReconnect);
    return () => {
      window.removeEventListener('online', handleReconnect);
    };
  }, []);

  useEffect(() => {
    setTitle('sidenav.equipments');
  }, [setTitle]);

  useEffect(() => {
    const measure = () => {
      const topH = document.getElementById('equipments-pdf-measure-top-header')?.offsetHeight ?? 150;
      const theadH = document.getElementById('equipments-pdf-measure-thead')?.offsetHeight ?? 28;
      const footerH = document.getElementById('equipments-pdf-measure-footer')?.offsetHeight ?? 80;
      const rowH = document.getElementById('equipments-pdf-measure-row')?.offsetHeight ?? 26;
      const availH = 1033 - topH - theadH - footerH - 20;
      setPdfRowsPerPage(Math.max(1, Math.floor(availH / rowH)));
    };
    const raf = requestAnimationFrame(measure);
    return () => cancelAnimationFrame(raf);
  }, []);

  useEffect(() => {
    fetchEquipments(currentPage, searchTerm, statusFilter, perPage);
  }, [currentPage, statusFilter, perPage]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setCurrentPage(1);
    setSearchTerm(value);
    setCurrentPage(1);
    fetchEquipments(1, value, statusFilter, perPage);
  };

  const handleApplyPerPage = () => {
    const total = pagination?.total || 0;
    const maxAllowed = total > 0 ? total : 1000;
    const next = Math.min(Math.max(1, parseInt(perPageInput) || 1), maxAllowed);
    setPerPage(next);
    setPerPageInput(next);
    setCurrentPage(1);
  };

  const handleDelete = async () => {
    if (!equipmentToDelete) return;

    const idToDelete = equipmentToDelete.id;
    const equipmentBackup = equipmentToDelete;

    // Optimistic deletion - remove from local state immediately
    setEquipments(prev => prev.filter(equipment => equipment.id !== idToDelete));
    setDeleteModalOpen(false);
    setEquipmentToDelete(null);

    try {
      await dispatch(deleteEquipments(idToDelete)).unwrap();
      toast.success(t('equipments.messages.deleteSuccess'), { rtl: isRTL });
      // Don't fetch - item already removed optimistically
    } catch (error) {
      // Rollback on error - restore the equipment
      setEquipments(prev => {
        // Find the position to insert back (maintain order)
        const index = prev.findIndex(eq => eq.id > idToDelete);
        if (index === -1) {
          return [...prev, equipmentBackup];
        }
        return [...prev.slice(0, index), equipmentBackup, ...prev.slice(index)];
      });
      let errorMsg = '';
      if (error && typeof error === 'string') {
        errorMsg = error;
      } else if (error && error.message) {
        errorMsg = error.message;
      } else {
        errorMsg = t('equipments.messages.deleteError', { defaultValue: 'فشل الحذف، تحقق من الاتصال أو الصلاحيات' });
      }
      toast.error(errorMsg, { rtl: isRTL });
    }
  };

  const handleToggleStatus = async (id) => {
    // Find the equipment to toggle
    const equipment = equipments.find(eq => eq.id === id);
    if (!equipment) return;

    const originalIsActive = equipment.is_active;
    const newIsActive = !originalIsActive;

    // Optimistic toggle - update local state immediately
    setEquipments(prev => prev.map(eq =>
      eq.id === id ? { ...eq, is_active: newIsActive } : eq
    ));

    try {
      await dispatch(toggleEquipmentStatus(id)).unwrap();
      toast.success(t('equipments.messages.toggleSuccess'), { rtl: isRTL });
      // Don't fetch - status already updated optimistically
    } catch (error) {
      // Rollback on error - restore original status
      setEquipments(prev => prev.map(eq =>
        eq.id === id ? { ...eq, is_active: originalIsActive } : eq
      ));
      toast.error(error || t('equipments.messages.toggleError'), { rtl: isRTL });
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '—';
    try {
      const date = new Date(dateString);
      const locale = 'en-US';
      return date.toLocaleDateString(locale, { year: 'numeric', month: '2-digit', day: '2-digit' });
    } catch {
      return dateString;
    }
  };

  // Handle print single equipment
  const handlePrintEquipment = async (equipment) => {
    try {
      setEquipmentForPrint(equipment);
      setPdfType('single');
      await new Promise((resolve) => requestAnimationFrame(() => resolve()));

      if (document.fonts && document.fonts.ready) {
        await document.fonts.ready;
      }
      await new Promise((resolve) => setTimeout(resolve, 300));

      setIsGeneratingPdf(true);

      const element = document.getElementById(`equipment-pdf-${equipment.id}`);
      if (!element) {
        toast.error(t('equipments.print.error', { defaultValue: 'خطأ في تحميل قالب الطباعة' }), { rtl: isRTL });
        return;
      }

      const devicePixelRatio = window.devicePixelRatio || 1;
      const scale = Math.max(3, devicePixelRatio * 2);

      const canvas = await html2canvas(element, {
        scale: scale,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
        letterRendering: true,
        allowTaint: false,
        removeContainer: false,
        imageTimeout: 15000,
        onclone: (clonedDoc) => {
          const clonedElement = clonedDoc.getElementById(`equipment-pdf-${equipment.id}`);
          if (clonedElement) {
            clonedElement.style.fontFamily = '"Times New Roman Bold", "Times New Roman", "Times", serif';
            clonedElement.style.fontWeight = 'bold';
            clonedElement.style.direction = isRTL ? 'rtl' : 'ltr';
            clonedElement.style.setProperty('-webkit-font-smoothing', 'antialiased');
            clonedElement.style.setProperty('-moz-osx-font-smoothing', 'grayscale');
            clonedElement.style.textRendering = 'optimizeLegibility';

            const allElements = clonedElement.querySelectorAll('*');
            allElements.forEach(el => {
              if (el.style) {
                el.style.fontFamily = '"Times New Roman Bold", "Times New Roman", "Times", serif';
                el.style.fontWeight = 'bold';
                el.style.setProperty('-webkit-font-smoothing', 'antialiased');
                el.style.setProperty('-moz-osx-font-smoothing', 'grayscale');
                el.style.textRendering = 'optimizeLegibility';
              }
            });
          }
        }
      });

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgData = canvas.toDataURL('image/png', 1.0);
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      if (imgHeight <= pdfHeight) {
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, imgHeight, undefined, 'FAST');
      } else {
        let position = 0;
        while (position < imgHeight) {
          if (position > 0) {
            pdf.addPage();
          }
          const remainingHeight = imgHeight - position;
          const pageHeight = Math.min(remainingHeight, pdfHeight);
          pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pageHeight, undefined, 'FAST');
          position += pdfHeight;
        }
      }

      const identifier = isRTL ? (equipment.name_ar || equipment.name_en) : (equipment.name_en || equipment.name_ar) || equipment.id;
      pdf.save(`ACE_Equipment_${identifier}_${new Date().toISOString().split('T')[0]}.pdf`);
    } catch (err) {
      console.error('Equipment PDF error:', err);
      toast.error(t('equipments.print.error', { defaultValue: 'حدث خطأ أثناء إنشاء PDF' }), { rtl: isRTL });
    } finally {
      setIsGeneratingPdf(false);
      setEquipmentForPrint(null);
      setPdfType(null);
    }
  };

  // Handle print all equipments — uses dynamic per-page chunks
  const handlePrintAll = async () => {
    if (!equipments || equipments.length === 0) {
      toast.error(t('equipments.print.noData', { defaultValue: 'لا توجد بيانات للطباعة' }), { rtl: isRTL });
      return;
    }

    try {
      setIsGeneratingPdf(true);
      await new Promise((r) => requestAnimationFrame(r));
      if (document.fonts && document.fonts.ready) await document.fonts.ready;
      await new Promise((r) => setTimeout(r, 300));

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const scale = Math.max(3, (window.devicePixelRatio || 1) * 2);

      for (let i = 0; i < pdfChunks.length; i++) {
        let element = document.getElementById(`equipments-pdf-all-${i}`);
        let retries = 0;
        while (!element && retries < 10) {
          await new Promise((r) => requestAnimationFrame(r));
          element = document.getElementById(`equipments-pdf-all-${i}`);
          if (!element) await new Promise((r) => setTimeout(r, 100));
          retries++;
        }
        if (!element) continue;

        const canvas = await html2canvas(element, {
          scale,
          useCORS: true,
          logging: false,
          backgroundColor: '#ffffff',
          letterRendering: true,
          allowTaint: false,
          removeContainer: false,
          imageTimeout: 15000,
          onclone: (clonedDoc) => {
            const cloned = clonedDoc.getElementById(`equipments-pdf-all-${i}`);
            if (cloned) {
              cloned.style.fontFamily = '"Times New Roman Bold", "Times New Roman", "Times", serif';
              cloned.style.fontWeight = 'bold';
              cloned.style.direction = isRTL ? 'rtl' : 'ltr';
              cloned.style.setProperty('-webkit-font-smoothing', 'antialiased');
              cloned.style.setProperty('-moz-osx-font-smoothing', 'grayscale');
              cloned.style.textRendering = 'optimizeLegibility';
              Array.from(cloned.querySelectorAll('*')).forEach((el) => {
                if (el.style) {
                  el.style.setProperty('-webkit-font-smoothing', 'antialiased');
                  el.style.setProperty('-moz-osx-font-smoothing', 'grayscale');
                  el.style.textRendering = 'optimizeLegibility';
                }
              });
            }
          },
        });

        const imgData = canvas.toDataURL('image/png', 1.0);
        const imgH = (canvas.height * pdfWidth) / canvas.width;
        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, Math.min(imgH, pdfHeight), undefined, 'FAST');
      }

      pdf.save(`ACE_Equipments_${new Date().toISOString().split('T')[0]}.pdf`);
    } catch (err) {
      console.error('Equipments PDF error:', err);
      toast.error(t('equipments.print.error', { defaultValue: 'حدث خطأ أثناء إنشاء ملف المعدات' }), { rtl: isRTL });
    } finally {
      setIsGeneratingPdf(false);
    }
  };

  // Handle export single equipment to Excel
  const handleExportEquipmentToExcel = (equipment) => {
    const data = [{
      [t('equipments.tableHeaders.nameAr', { defaultValue: 'الاسم بالعربية' })]: equipment.name_ar || '—',
      [t('equipments.tableHeaders.nameEn', { defaultValue: 'الاسم بالإنجليزية' })]: equipment.name_en || '—',
      [t('equipments.tableHeaders.code', { defaultValue: 'الكود' })]: equipment.code || '—',
      [t('equipments.tableHeaders.quantity', { defaultValue: 'الكمية' })]: equipment.quantity ?? '—',
      [t('equipments.tableHeaders.status', { defaultValue: 'الحالة' })]: equipment.is_active ? t('equipments.active') : t('equipments.inactive')
    }];

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, isRTL ? 'معدة' : 'Equipment');
    const identifier = isRTL ? (equipment.name_ar || equipment.name_en) : (equipment.name_en || equipment.name_ar) || equipment.id;
    const fileName = `${isRTL ? 'معدة' : 'Equipment'}_${identifier}_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(wb, fileName);
    toast.success(t('equipments.export.success', { defaultValue: 'تم تصدير البيانات بنجاح' }), { rtl: isRTL });
  };

  // Handle export all equipments to Excel
  const handleExportAllToExcel = () => {
    if (!equipments || equipments.length === 0) {
      toast.error(t('equipments.export.noData', { defaultValue: 'لا توجد بيانات للتصدير' }), { rtl: isRTL });
      return;
    }

    const data = equipments.map((equipment, index) => ({
      'م': (paginationInfo.current_page - 1) * perPage + (index + 1),
      [t('equipments.tableHeaders.nameAr', { defaultValue: 'الاسم بالعربية' })]: equipment.name_ar || '—',
      [t('equipments.tableHeaders.nameEn', { defaultValue: 'الاسم بالإنجليزية' })]: equipment.name_en || '—',
      [t('equipments.tableHeaders.code', { defaultValue: 'الكود' })]: equipment.code || '—',
      [t('equipments.tableHeaders.quantity', { defaultValue: 'الكمية' })]: equipment.quantity ?? '—',
      [t('equipments.tableHeaders.status', { defaultValue: 'الحالة' })]: equipment.is_active ? t('equipments.active') : t('equipments.inactive')
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, isRTL ? 'المعدات' : 'Equipments');
    const fileName = `${isRTL ? 'المعدات' : 'Equipments'}_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(wb, fileName);
    toast.success(t('equipments.export.success', { defaultValue: 'تم تصدير البيانات بنجاح' }), { rtl: isRTL });
  };

  return (
    <div style={{ padding: 30, backgroundColor: '#14263b', minHeight: 'calc(100vh - 80px)', color: 'white', direction: isRTL ? 'rtl' : 'ltr' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20, alignItems: 'center', marginBottom: 24 }}>
        <div style={{ position: 'relative', flex: 1, minWidth: 260 }}>
          <FaSearch style={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)', color: '#888' }} />
          <input
            type="text"
            value={searchTerm}
            onChange={handleSearchChange}
            placeholder={t('equipments.searchPlaceholder')}
            style={{
              width: '100%',
              padding: '12px 16px 12px 42px',
              backgroundColor: '#1a1f2e',
              border: '1px solid #333',
              borderRadius: 8,
              color: 'white',
              direction: isRTL ? 'rtl' : 'ltr',
              textAlign: isRTL ? 'right' : 'left',
            }}
          />
        </div>
        <select
          value={statusFilter}
          onChange={(e) => {
            setStatusFilter(e.target.value);
            setCurrentPage(1);
          }}
          style={{
            minWidth: 140,
            padding: '12px',
            backgroundColor: '#1a1f2e',
            border: '1px solid #333',
            borderRadius: 8,
            color: 'white',
            direction: isRTL ? 'rtl' : 'ltr',
            textAlign: isRTL ? 'right' : 'left',
          }}
        >
          <option value="">{t('equipments.allStatuses')}</option>
          <option value="1">{t('equipments.active')}</option>
          <option value="0">{t('equipments.inactive')}</option>
        </select>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <label style={{ color: 'white', fontSize: '14px', whiteSpace: 'nowrap' }}>
              {t('common.perPage', { defaultValue: 'Per Page' })}:
            </label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <button
                onClick={() => {
                  const newValue = Math.max(1, perPageInput - 1);
                  setPerPageInput(newValue);
                }}
                style={{
                  backgroundColor: '#1b3350',
                  color: 'white',
                  border: '1px solid #333',
                  padding: '6px 10px',
                  borderRadius: '6px 0 0 6px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: '32px'
                }}
              >
                −
              </button>
              <input
                type="number"
                min="1"
                max={pagination?.total || 1000}
                value={perPageInput}
                onChange={(e) => {
                  const value = parseInt(e.target.value, 10) || 1;
                  const maxValue = pagination?.total || 1000;
                  setPerPageInput(Math.max(1, Math.min(maxValue, value)));
                }}
                style={{
                  width: '70px',
                  padding: '6px 10px',
                  backgroundColor: '#1a1f2e',
                  border: '1px solid #333',
                  borderLeft: 'none',
                  borderRight: 'none',
                  borderRadius: 0,
                  color: 'white',
                  fontSize: '14px',
                  textAlign: 'center'
                }}
              />
              <button
                onClick={() => {
                  const maxValue = pagination?.total || 1000;
                  const newValue = Math.min(maxValue, perPageInput + 1);
                  setPerPageInput(newValue);
                }}
                style={{
                  backgroundColor: '#1b3350',
                  color: 'white',
                  border: '1px solid #333',
                  padding: '6px 10px',
                  borderRadius: '0 6px 6px 0',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: '32px'
                }}
              >
                +
              </button>
            </div>
            <button
              onClick={handleApplyPerPage}
              style={{
                backgroundColor: '#AC2000',
                color: 'white',
                border: 'none',
                padding: '6px 12px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                whiteSpace: 'nowrap'
              }}
            >
              {t('common.apply', { defaultValue: 'تطبيق' })}
            </button>
          </div>
          <button
            onClick={() => {
              if (!equipments || equipments.length === 0) {
                toast.error(t('equipments.print.noData', { defaultValue: 'لا توجد بيانات للمعاينة' }), { rtl: isRTL });
                return;
              }
              setPreviewType('all');
              setPreviewEquipment(null);
              setIsPreviewOpen(true);
            }}
            style={{
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              padding: '12px 20px',
              borderRadius: 8,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 8
            }}
          >
            <FaEye /> {t('equipments.print.previewAll', { defaultValue: 'معاينة PDF للكل' })}
          </button>
          <button
            onClick={handlePrintAll}
            disabled={isGeneratingPdf}
            style={{
              backgroundColor: isGeneratingPdf ? '#666' : '#17a2b8',
              color: 'white',
              border: 'none',
              padding: '12px 20px',
              borderRadius: 8,
              cursor: isGeneratingPdf ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              opacity: isGeneratingPdf ? 0.6 : 1
            }}
          >
            <FaPrint /> {isGeneratingPdf ? t('equipments.print.generating', { defaultValue: 'جاري الطباعة...' }) : t('equipments.print.all', { defaultValue: 'طباعة الكل' })}
          </button>
          <button
            onClick={handleExportAllToExcel}
            style={{
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              padding: '12px 20px',
              borderRadius: 8,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 8
            }}
          >
            <FaFileExcel /> {t('equipments.export.all', { defaultValue: 'تصدير Excel الكل' })}
          </button>
          <button
            onClick={() => navigate('/equipments/add')}
            style={{
              backgroundColor: '#AC2000',
              color: 'white',
              border: 'none',
              padding: '12px 20px',
              borderRadius: 8,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}
          >
            <FaPlus /> {t('equipments.addNew')}
          </button>
        </div>
      </div>

      <div style={{ backgroundColor: '#1b3350', border: '1px solid #333', borderRadius: 12, overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 900 }}>
            <thead>
              <tr style={{ backgroundColor: '#AC2000' }}>
                {[
                  { text: t('equipments.tableHeaders.number'), align: 'center' },
                  { text: isRTL ? t('equipments.tableHeaders.nameAr') : t('equipments.tableHeaders.nameEn'), align: isRTL ? 'right' : 'left' },
                  { text: t('equipments.tableHeaders.code'), align: isRTL ? 'right' : 'left' },
                  { text: t('equipments.tableHeaders.quantity', { defaultValue: 'الكمية' }), align: 'center' },
                  { text: t('equipments.tableHeaders.status'), align: 'center' },
                  { text: t('equipments.tableHeaders.actions'), align: 'center' }
                ].map((header, index) => (
                  <th
                    key={index}
                    style={{
                      padding: 14,
                      textAlign: header.align,
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: 14,
                      borderBottom: '1px solid #333',
                    }}
                  >
                    {header.text}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={6} style={{ textAlign: 'center', padding: 20, color: '#ccc' }}>
                    {t('equipments.loading')}
                  </td>
                </tr>
              ) : equipments.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ textAlign: 'center', padding: 20, color: '#ccc' }}>
                    {t('equipments.noData')}
                  </td>
                </tr>
              ) : (
                equipments.map((equipment, index) => (
                  <tr key={equipment.id || index} style={{ borderBottom: '1px solid #333' }}>
                    <td style={cellStyle}>{(paginationInfo.current_page - 1) * perPage + (index + 1)}</td>
                    <td style={{ ...cellStyle, direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>
                      {isRTL ? (equipment.name_ar || '—') : (equipment.name_en || '—')}
                    </td>
                    <td style={{ ...cellStyle, direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>{equipment.code || '—'}</td>
                    <td style={{ ...cellStyle, textAlign: 'center' }}>{equipment.quantity ?? '—'}</td>
                    <td style={cellStyle}>
                      <span
                        style={{
                          padding: '4px 12px',
                          borderRadius: 20,
                          backgroundColor: equipment.is_active ? 'rgba(39,174,96,0.15)' : 'rgba(192,57,43,0.2)',
                          color: equipment.is_active ? '#2ecc71' : '#e74c3c',
                          fontWeight: 'bold',
                          fontSize: 12,
                        }}
                      >
                        {equipment.is_active ? t('equipments.active') : t('equipments.inactive')}
                      </span>
                    </td>
                    <td style={{ ...cellStyle, minWidth: 200 }}>
                      <div style={{ display: 'flex', justifyContent: 'center', gap: 8, flexWrap: 'nowrap' }}>
                        <ActionButton
                          title={t('equipments.print.previewSingle', { defaultValue: 'معاينة PDF' })}
                          onClick={() => {
                            setPreviewEquipment(equipment);
                            setPreviewType('single');
                            setIsPreviewOpen(true);
                          }}
                        >
                          <FaEye />
                        </ActionButton>
                        <ActionButton title={t('equipments.print.single', { defaultValue: 'طباعة' })} onClick={() => handlePrintEquipment(equipment)} disabled={isGeneratingPdf} style={{ opacity: isGeneratingPdf ? 0.6 : 1 }}>
                          <FaPrint />
                        </ActionButton>
                        <ActionButton title={t('equipments.export.single', { defaultValue: 'تصدير Excel' })} onClick={() => handleExportEquipmentToExcel(equipment)} bg="#28a745">
                          <FaFileExcel />
                        </ActionButton>
                        <ActionButton title={t('equipments.actions.edit')} onClick={() => navigate(`/equipments/edit/${equipment.id}`)}>
                          <FaEdit />
                        </ActionButton>
                        <ActionButton
                          title={t('equipments.actions.expenses')}
                          bg="#27ae60"
                          onClick={() => navigate(`/equipment-expenses?equipment_id=${equipment.id}`)}
                        >
                          <FaDollarSign />
                        </ActionButton>
                        <ActionButton
                          title={t('equipments.actions.delete')}
                          bg="#c0392b"
                          onClick={() => {
                            setEquipmentToDelete(equipment);
                            setDeleteModalOpen(true);
                          }}
                        >
                          <FaTrash />
                        </ActionButton>
                        <ActionButton
                          title={t('equipments.actions.toggleStatus')}
                          bg="#34495e"
                          onClick={() => handleToggleStatus(equipment.id)}
                        >
                          {equipment.is_active ? <FaToggleOn /> : <FaToggleOff />}
                        </ActionButton>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, padding: 16, borderTop: '1px solid #333' }}>
          <button
            onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
            disabled={paginationInfo.current_page === 1}
            style={paginationButton(paginationInfo.current_page === 1)}
          >
            {t('equipments.previous')}
          </button>
          <span style={{ padding: 8 }}>
            {paginationInfo.current_page} / {paginationInfo.last_page}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => (prev >= paginationInfo.last_page ? paginationInfo.last_page : prev + 1))
            }
            disabled={paginationInfo.current_page >= paginationInfo.last_page}
            style={paginationButton(paginationInfo.current_page >= paginationInfo.last_page)}
          >
            {t('equipments.next')}
          </button>
        </div>
      </div>
      {deleteModalOpen && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalCardStyle, direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>
            <h3 style={{ marginTop: 0, marginBottom: 12 }}>{t('equipments.deleteModal.title')}</h3>
            <p style={{ marginBottom: 24 }}>
              {t('equipments.deleteModal.message')}{' '}
              <strong>{isRTL
                ? (equipmentToDelete?.name_ar || equipmentToDelete?.name_en)
                : (equipmentToDelete?.name_en || equipmentToDelete?.name_ar)}</strong>؟
            </p>
            <div style={{ display: 'flex', justifyContent: isRTL ? 'flex-end' : 'flex-start', gap: 12, flexDirection: isRTL ? 'row' : 'row-reverse' }}>
              <button
                style={modalSecondaryButtonStyle}
                onClick={() => {
                  setDeleteModalOpen(false);
                  setEquipmentToDelete(null);
                }}
              >
                {t('equipments.deleteModal.cancel')}
              </button>
              <button style={modalPrimaryButtonStyle} onClick={handleDelete}>
                {t('equipments.deleteModal.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Hidden measure elements for dynamic PDF pagination — always in DOM */}
      <div
        aria-hidden="true"
        style={{ position: 'absolute', left: '-9999px', top: 0, width: '714px', backgroundColor: '#ffffff', fontFamily: '"Times New Roman", serif', fontSize: '11px', boxSizing: 'border-box' }}
      >
        <div id="equipments-pdf-measure-top-header" style={{ paddingBottom: '8px', marginBottom: '8px', borderBottom: '4px double #000' }}>
          <img src={`${publicUrl}/HeaderAce.png`} alt="" style={{ width: '100%', height: 'auto', objectFit: 'contain' }} crossOrigin="anonymous" />
          <h2 style={{ textAlign: 'center', fontSize: '16px', fontWeight: '700', margin: '8px 0 4px' }}>{isRTL ? 'تقرير المعدات' : 'Equipments Report'}</h2>
          <p style={{ textAlign: 'center', fontSize: '11px', margin: '0 0 4px' }}>Date</p>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px', border: '1px solid #000' }}>
          <thead id="equipments-pdf-measure-thead">
            <tr style={{ backgroundColor: 'rgba(238, 242, 247, 0.7)' }}>
              <th style={{ border: '1px solid #000', padding: '6px', width: '36px', textAlign: 'center' }}>#</th>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}>Name</th>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}>Name</th>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}>Code</th>
              <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr id="equipments-pdf-measure-row">
              <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', verticalAlign: 'middle' }}>1</td>
              <td style={{ border: '1px solid #000', padding: '6px', verticalAlign: 'middle' }}>—</td>
              <td style={{ border: '1px solid #000', padding: '6px', verticalAlign: 'middle' }}>—</td>
              <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', verticalAlign: 'middle' }}>—</td>
              <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', verticalAlign: 'middle' }}>—</td>
            </tr>
          </tbody>
        </table>
        <div id="equipments-pdf-measure-footer">
          <img src={`${publicUrl}/FooterAce.png`} alt="" style={{ width: '100%', height: 'auto', objectFit: 'contain', borderTop: '4px double #000' }} crossOrigin="anonymous" />
        </div>
      </div>

      {/* Hidden PDF Template — single equipment */}
      {equipmentForPrint && pdfType === 'single' && (
        <div
          id={`equipment-pdf-${equipmentForPrint.id}`}
          aria-hidden="true"
          style={{
            position: 'absolute',
            left: '-9999px',
            top: 0,
            width: '794px',
            minHeight: '1123px',
            backgroundColor: '#ffffff',
            color: '#000000',
            fontFamily: '"Times New Roman Bold", "Times New Roman", "Times", serif',
            fontWeight: 'bold',
            padding: '40px',
            boxSizing: 'border-box',
          }}
        >
          <SingleEquipmentPrintTemplate
            equipment={equipmentForPrint}
            isRTL={isRTL}
            t={t}
            publicUrl={publicUrl}
            headerLogo={headerLogo}
          />
        </div>
      )}

      {/* Hidden print pages for all equipments — one page per chunk */}
      {pdfChunks.length > 0 && (
        <div aria-hidden="true" style={{ position: 'absolute', left: '-9999px', top: 0, width: '794px' }}>
          {pdfChunks.map((chunk, i) => (
            <EquipmentsPdfPage
              key={i}
              id={`equipments-pdf-all-${i}`}
              chunk={chunk}
              chunkIndex={i}
              totalChunks={pdfChunks.length}
              isPreview={false}
              isRTL={isRTL}
              t={t}
              publicUrl={publicUrl}
              headerLogo={headerLogo}
              activeFilters={activeFiltersForPdf}
            />
          ))}
        </div>
      )}

      {/* PDF Preview Modal */}
      <PdfPreviewModal
        isOpen={isPreviewOpen}
        title={previewType === 'all' ? t('equipments.preview.titleAll') : t('equipments.preview.title')}
        onClose={() => {
          setIsPreviewOpen(false);
          setPreviewEquipment(null);
          setPreviewType(null);
        }}
        onPrint={previewType === 'all' ? handlePrintAll : previewEquipment ? () => handlePrintEquipment(previewEquipment) : undefined}
        isGeneratingPdf={isGeneratingPdf}
      >
        {previewType === 'single' && previewEquipment && (
          <div
            id={`equipment-pdf-preview-${previewEquipment.id}`}
            style={{
              width: '794px',
              minHeight: '1123px',
              backgroundColor: '#ffffff',
              color: '#000000',
              fontFamily: '"Times New Roman Bold", "Times New Roman", "Times", serif',
              fontWeight: 'bold',
              padding: '40px',
              boxSizing: 'border-box',
            }}
          >
            <SingleEquipmentPrintTemplate
              equipment={previewEquipment}
              isRTL={isRTL}
              t={t}
              publicUrl={publicUrl}
              headerLogo={headerLogo}
            />
          </div>
        )}
        {previewType === 'all' && pdfChunks.map((chunk, i) => (
          <EquipmentsPdfPage
            key={i}
            chunk={chunk}
            chunkIndex={i}
            totalChunks={pdfChunks.length}
            isPreview={true}
            isRTL={isRTL}
            t={t}
            publicUrl={publicUrl}
            headerLogo={headerLogo}
            activeFilters={activeFiltersForPdf}
          />
        ))}
      </PdfPreviewModal>
    </div>
  );
};

// Print Template for Single Equipment
const SingleEquipmentPrintTemplate = ({ equipment, isRTL, t, publicUrl, headerLogo }) => {
  return (
    <div style={{
      border: '5px solid #000',
      padding: '3px',
      backgroundColor: '#ffffff',
      boxSizing: 'border-box',
      width: '100%',
      minHeight: '1043px',
    }}>
      <div style={{
        border: '2px solid #000',
        minHeight: '1033px',
        height: '1033px',
        padding: '18px 18px 10px',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: '"Times New Roman Bold", "Times New Roman", "Times", serif',
        fontWeight: 'bold',
        direction: isRTL ? 'rtl' : 'ltr',
        backgroundColor: '#ffffff',
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(${headerLogo})`,
          backgroundSize: '95%',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          opacity: 0.08,
          zIndex: 0,
          pointerEvents: 'none'
        }} />
        <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
          <img
            src={`${publicUrl}/HeaderAce.png`}
            alt="Header"
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'contain',
              marginBottom: '8px',
              borderBottom: '4px double #000',
              paddingBottom: '8px',
              flexShrink: 0
            }}
            crossOrigin="anonymous"
          />
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'visible', minHeight: 0, paddingBottom: '120px' }}>
            <div style={{ marginTop: '8px', direction: isRTL ? 'rtl' : 'ltr', fontFamily: '"Times New Roman", "Times", serif' }}>
              <h2 style={{ textAlign: 'center', fontSize: '16px', fontWeight: '700', color: '#000080', margin: '0 0 4px', fontFamily: '"Times New Roman", serif' }}>
                {isRTL ? 'تقرير المعدة' : 'Equipment Report'}
              </h2>
              <p style={{ textAlign: 'center', fontSize: '11px', margin: '0 0 8px', fontFamily: '"Times New Roman", serif', color: '#333' }}>
                {new Date().toLocaleDateString(isRTL ? 'ar-SA' : 'en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px', border: '1px solid #000', fontFamily: '"Times New Roman", "Times", serif', backgroundColor: 'rgba(255, 255, 255, 0.7)' }}>
                <thead>
                  <tr style={{ backgroundColor: 'rgba(238, 242, 247, 0.7)' }}>
                    <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', fontWeight: '700', backgroundColor: 'rgba(238, 242, 247, 0.7)' }}>{t('equipments.printTemplate.nameAr')}</th>
                    <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', fontWeight: '700', backgroundColor: 'rgba(238, 242, 247, 0.7)' }}>{t('equipments.printTemplate.nameEn')}</th>
                    <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', fontWeight: '700', backgroundColor: 'rgba(238, 242, 247, 0.7)' }}>{t('equipments.printTemplate.code')}</th>
                    <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', fontWeight: '700', backgroundColor: 'rgba(238, 242, 247, 0.7)' }}>{t('equipments.printTemplate.status')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)' }}>
                    <td style={{ border: '1px solid #000', padding: '6px', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left', verticalAlign: 'middle', backgroundColor: 'rgba(255, 255, 255, 0.7)' }}>{equipment.name_ar || '—'}</td>
                    <td style={{ border: '1px solid #000', padding: '6px', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left', verticalAlign: 'middle', backgroundColor: 'rgba(255, 255, 255, 0.7)' }}>{equipment.name_en || '—'}</td>
                    <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', verticalAlign: 'middle', backgroundColor: 'rgba(255, 255, 255, 0.7)' }}>{equipment.code || '—'}</td>
                    <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', verticalAlign: 'middle', backgroundColor: 'rgba(255, 255, 255, 0.7)' }}>{equipment.is_active ? t('equipments.active') : t('equipments.inactive')}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style={{ position: 'absolute', bottom: '10px', left: '18px', right: '18px', flexShrink: 0 }}>
            <img
              src={`${publicUrl}/FooterAce.png`}
              alt="Footer"
              style={{ width: '100%', height: 'auto', objectFit: 'contain', borderTop: '4px double #000' }}
              crossOrigin="anonymous"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const cellStyle = {
  padding: 14,
  textAlign: 'center',
  color: 'white',
  fontSize: 14,
};

const paginationButton = (disabled) => ({
  padding: '8px 16px',
  backgroundColor: disabled ? '#333' : '#AC2000',
  color: 'white',
  border: 'none',
  borderRadius: 6,
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.6 : 1,
});

const ActionButton = ({ children, onClick, title, bg = '#2f3644' }) => (
  <button
    onClick={onClick}
    title={title}
    style={{
      backgroundColor: bg,
      color: 'white',
      border: 'none',
      borderRadius: 6,
      padding: '8px 10px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 38,
    }}
  >
    {children}
  </button>
);

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
  padding: 16,
};

const modalCardStyle = {
  backgroundColor: '#1b3350',
  borderRadius: 12,
  padding: 24,
  border: '1px solid #333',
  width: '100%',
  maxWidth: 420,
};

const modalPrimaryButtonStyle = {
  backgroundColor: '#AC2000',
  color: 'white',
  border: 'none',
  borderRadius: 8,
  padding: '10px 18px',
  cursor: 'pointer',
};

const modalSecondaryButtonStyle = {
  backgroundColor: 'transparent',
  color: 'white',
  border: '1px solid #444',
  borderRadius: 8,
  padding: '10px 18px',
  cursor: 'pointer',
};

export default Equipments;

